import { Capacitor } from '@capacitor/core';

export type SignupPlatform = 'web' | 'ios' | 'android';

/**
 * The client an account is being created on (ORA-900). Only the native
 * App Store / Play Store shells report 'ios' / 'android'; a mobile browser is
 * 'web' on purpose — this tracks the app, not the device, so it must not use
 * the user-agent based `getPlatform`.
 */
export const getSignupPlatform = (): SignupPlatform => {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios' || platform === 'android') return platform;
  return 'web';
};
